import { Avatar, Text } from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';
import { User } from 'lib-shared-types-api';

import styles from './conversationLegacyPreviewCustomer.module.scss';

type ConversationLegacyPreviewCustomerProps = {
  requester: User | null | undefined;
  showSectionIcon?: boolean;
};

export const ConversationLegacyPreviewCustomer = ({
  requester,
  showSectionIcon,
}: ConversationLegacyPreviewCustomerProps): JSX.Element | null => {
  if (!requester) {
    return null;
  }

  const details = [requester.email, requester.phone_number].filter(
    (detail): detail is string => Boolean(detail),
  );

  if (!requester.name && details.length === 0) {
    return null;
  }

  return (
    <div className={styles.root}>
      {showSectionIcon && (
        <Avatar
          className={styles.icon}
          icon="user"
          color={{
            contentColor: colors.neutral[700],
            backgroundColor: colors.neutral[100],
          }}
        />
      )}

      {requester.name && (
        <Text.Paragraph variant="1" className={styles.name}>
          {requester.name}
        </Text.Paragraph>
      )}

      {details.length > 0 && (
        <Text.Paragraph variant="3" subdued className={styles.details}>
          {details.join(' · ')}
        </Text.Paragraph>
      )}
    </div>
  );
};
